import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_HOUSEHOLD_SUBMIT_GUARANTOR_APPLICATION,
} from 'api/actionTypes';

import analytics from 'client/analytics';
import {
  ANALYTICS_EVENT_GUARANTOR_APPLICATION_FORM_SUBMIT,
} from 'client/analytics/eventList';

import submitRenterProfileAction from 'client/actions/Household/submitRenterProfile';

import getHouseholdApplicationsAction from 'client/actions/Household/getApplications';

export default async function submitGuarantorApplication({ state, apiClient }, params) {
  const {
    userId,
    householdId,
    listingId,
    guarantorApplication,
  } = params;

  typeCheck('userId::PositiveNumber', userId);
  typeCheck('householdId::PositiveNumber', householdId);
  typeCheck('guarantorApplication::NonEmptyObject', guarantorApplication);

  // Update renter profile.
  await submitRenterProfileAction({ state, apiClient }, {
    userId: userId,
    householdApplication: guarantorApplication,
  });

  // Submit guarantor application.
  const submitGuarantorApplicationResult = await apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_SUBMIT_GUARANTOR_APPLICATION,
    state: state,
    payload: {
      userId,
      householdId,
      listingId,
      guarantorApplication,
    },
  });

  analytics.track(ANALYTICS_EVENT_GUARANTOR_APPLICATION_FORM_SUBMIT, {
    householdId,
  });

  await getHouseholdApplicationsAction({ state, apiClient }, {
    userId: userId,
  });

  return submitGuarantorApplicationResult;
}
